import React, { type ReactNode, type RefObject } from 'react';
import { createPortal } from 'react-dom';
import type { PopoverPosition } from './usePopover';
import styles from './DatePicker.module.scss';

interface PopoverProps {
    id: string;
    label: string;
    popoverRef: RefObject<HTMLDivElement | null>;
    position: PopoverPosition;
    children: ReactNode;
}

export const Popover = ({ id, label, popoverRef, position, children }: PopoverProps) =>
    createPortal(
        <div
            ref={popoverRef}
            id={id}
            role="dialog"
            aria-label={label}
            className={styles.popover}
            style={{ top: position.top, left: position.left }}
        >
            {children}
        </div>,
        document.body,
    );